import type { FC } from 'react';
import React from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Lottie from 'react-lottie';

import setupRocketAnimation from '@pages/common/Onboarding/const/hubmee-rocket_pop-up.json';
import { useAppSelector } from '@shared/hooks/redux';
import { MuiButton } from 'shared/ui-kit';

type OnboardingCompletePropsType = {
  closeModal: () => void;
};

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: setupRocketAnimation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};
export const OnboardingComplete: FC<OnboardingCompletePropsType> = ({ closeModal }) => {
  const userName = useAppSelector((state) => state.profile.data?.first_name);
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      width="100%"
      display="flex"
      justifyContent="center"
      pt={'16px'}
      mt={'16px'}
      borderTop={`1px solid ${theme.palette.case.neutral.n200}`}
    >
      <Box display="flex" justifyContent="center" flexDirection="column" maxWidth="360px">
        <Lottie isClickToPauseDisabled={true} options={defaultOptions} height={200} width={200} />

        <Typography variant="s1" sx={{ color: theme.palette.case.neutral.n900, textAlign: 'center' }}>
          {t('onboardingSetup.onboardingComplete.awesomeJob', {
            userName: userName,
          })}
        </Typography>
        <Typography variant="t14r" sx={{ color: theme.palette.case.neutral.n700, textAlign: 'center' }}>
          {t('onboardingSetup.onboardingComplete.together')}
        </Typography>

        <Box display="flex" justifyContent="center" mt="24px">
          <MuiButton label="Done" variant="contained" size={'medium'} onClick={closeModal} />
        </Box>
      </Box>
    </Box>
  );
};
